import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=58e6d2ae"
import script from "./InfoTab.vue?vue&type=script&lang=js"
export * from "./InfoTab.vue?vue&type=script&lang=js"
import style0 from "./InfoTab.vue?vue&type=style&index=0&id=58e6d2ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports